<template>
  <Content :style="{padding: '0 0 27px 27px'}">
    <div class="stores_title">
      <Breadcrumb>
        <BreadcrumbItem>用户权限管理</BreadcrumbItem>
        <BreadcrumbItem>用户管理</BreadcrumbItem>
        <BreadcrumbItem>{{isAdd ? '添加用户' : '编辑用户'}}</BreadcrumbItem>
      </Breadcrumb>
      <p @click="console">{{isAdd ? '添加用户' : '编辑用户'}}</p>
    </div>
    <div class="stores_container mt20">
      <p class="lable-title">基本信息</p>
      <div class="userInfo">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120" class="form">
          <Row>
            <Col span="8">
            <FormItem label="用户名：" prop="UserName" class="item margin_small">
              <Input v-model="formValidate.UserName" placeholder="请输入用户名"></Input>
            </FormItem>
            </Col>
            <Col span="8">
            <FormItem label="真实姓名：" prop="RealName" class="item margin_small">
              <Input v-model="formValidate.RealName" placeholder="请输入真实姓名"></Input>
            </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span="8">
            <FormItem label="手机：" prop="Mobile" class="item margin_small">
              <Input v-model="formValidate.Mobile" placeholder="请输入电话号码"></Input>
            </FormItem>
            </Col>
            <Col span="8">
            <FormItem label="邮箱：" prop="Email" class="item margin_small">
              <Input v-model="formValidate.Email" placeholder="请输入邮箱"></Input>
            </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span="8">
            <FormItem v-if="userId == 0" label="登录密码：" prop="Password" class="item margin_small">
              <Input type="password" v-model="formValidate.Password" placeholder="请输入登录密码"></Input>
            </FormItem>
            </Col>
            <Col span="8">
            <FormItem v-if="userId == 0" label="确认密码：" prop="RPassword" class="item margin_small">
              <Input type="password" v-model="formValidate.RPassword" placeholder="请输入确认密码"></Input>
            </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span="8">
            <FormItem label="备注：" prop="Remark" class="item margin_small">
              <Input v-model="formValidate.Remark" type="textarea" :autosize="{minRows: 1,maxRows: 5}"
                     placeholder="请输入备注信息"></Input>
            </FormItem>
            </Col>
          </Row>

        </Form>
        <div class="upload">
        </div>
      </div>

      <p class="lable-title mt20">角色管理</p>
      <div class="userInfo">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120" class="form">
          <Row :gutter="16">
            <Col span="8">
            <FormItem label="选择角色" prop="Roles">
              <Select v-model="formValidate.Roles" multiple>
                <Option v-for="item in RoleData" :value="item.Id" :key="item.Id">{{ item.Name }}
                </Option>
              </Select>
            </FormItem>
            </Col>
            <Col span="2">
              <Button @click="addRole">添加</Button>
            </Col>
          </Row>

          <Row>
            <Col span="8">
            <FormItem label="温馨提示">
              <Alert>普通用户角色不能对设备进行添加、编辑、删除等相关操作</Alert>
            </FormItem>
            </Col>
          </Row>
        </Form>
      </div>

      <p class="lable-title mt20">设备权限管理</p>
      <div class="deviceManage mt10">
        <Tabs class="tabs" @on-click="">
          <TabPane label="传感器设备">
            <Collapse accordion v-for="item in deviceAllList" :key="item.GroupName" v-if="item.Sensors.length > 0">
              <Panel name="1">
                &nbsp;&nbsp;
                <Checkbox
                  :value="item.sensorIsChecked"
                  :indeterminate="item.sensorIndeterminate"
                  @click.prevent.stop.native="handleCheckAll(item.GroupName,1)">
                  &nbsp;{{item.GroupName}}：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </Checkbox>
                <p slot="content">
                  <Checkbox v-for="vv in item.Sensors" :key="vv.Id" v-model="vv.isChecked"
                            @on-change="checkAllGroupChange()">{{vv.Name}}
                  </Checkbox>
                </p>
              </Panel>
            </Collapse>
          </TabPane>
          <TabPane label="控制器设备">
            <Collapse accordion v-for="item in deviceAllList" :key="item.GroupName" v-if="item.Controllers.length > 0">
              <Panel name="1">
                &nbsp;&nbsp;
                <Checkbox
                  :value="item.controllerIsChecked"
                  :indeterminate="item.controllerIndeterminate"
                  @click.prevent.stop.native="handleCheckAll(item.GroupName,2)">
                  &nbsp;{{item.GroupName}}：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </Checkbox>
                <p slot="content">
                  <Checkbox v-for="vv in item.Controllers" :key="vv.Id" v-model="vv.isChecked"
                            @on-change="checkAllGroupChange()">{{vv.Name}}
                  </Checkbox>
                </p>
              </Panel>
            </Collapse>
          </TabPane>
          <TabPane label="视频设备">
            <Collapse accordion v-for="item in deviceAllList" :key="item.GroupName" v-if="item.Cameras.length > 0">
              <Panel name="1">
                &nbsp;&nbsp;
                <Checkbox
                  :value="item.cameraIsChecked"
                  :indeterminate="item.cameraIndeterminate"
                  @click.prevent.stop.native="handleCheckAll(item.GroupName,3)">
                  &nbsp;{{item.GroupName}}：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </Checkbox>
                <p slot="content">
                  <Checkbox v-for="vv in item.Cameras" :key="vv.Id" v-model="vv.isChecked"
                            @on-change="checkAllGroupChange()">{{vv.Name}}
                  </Checkbox>
                </p>
              </Panel>
            </Collapse>
          </TabPane>

          <TabPane label="水肥机设备">
            <Collapse accordion v-for="item in deviceAllList" :key="item.GroupName" v-if="item.Irrigations.length > 0">
              <Panel name="1">
                &nbsp;&nbsp;
                <Checkbox
                  :value="item.irrigationIsChecked"
                  :indeterminate="item.irrigationIndeterminate"
                  @click.prevent.stop.native="handleCheckAll(item.GroupName,4)">
                  &nbsp;{{item.GroupName}}：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </Checkbox>
                <p slot="content">
                  <Checkbox v-for="vv in item.Irrigations" :key="vv.Id" v-model="vv.isChecked"
                            @on-change="checkAllGroupChange()">{{vv.Name}}
                  </Checkbox>
                </p>
              </Panel>
            </Collapse>
          </TabPane>

          <Input class="search" v-model="Search" placeholder="请输入关键词" slot="extra" style="width: 200px"></Input>
          <!--<img class="searchPic" src="@/assets/img/search.png" alt="" slot="extra" @click="searchFn">-->
        </Tabs>

      </div>

      <div class="btn_group mt20">
        <Button size="large" type="primary" @click="handleSubmit('formValidate')">提交</Button>
        <Button size="large" @click="handleReset()" style="margin-left: 8px">取消</Button>
      </div>
    </div>

    <Modal
      v-model="showRoleBox"
      :styles="{top: '200px'}"
    >
      <p slot="header">
        <span>添加角色</span>
      </p>
      <div>
        <Form ref="roleFormValidate" :model="roleFormValidate" :rules="roleRuleValidate" :label-width="80">
          <FormItem label="角色类别" prop="Level">
            <Select v-model="roleFormValidate.Level" placeholder="请选择角色类别">
              <Option v-for="item in roleList" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

          <FormItem label="角色名称" prop="Name">
            <Input v-model="roleFormValidate.Name" placeholder="请输入角色名称"/>
          </FormItem>

          <FormItem label="是否有效" prop="IsValid">
            <RadioGroup v-model="roleFormValidate.IsValid">
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </FormItem>

          <FormItem label="备注" prop="Remark">
            <Input v-model="roleFormValidate.Remark" placeholder="请输入备注信息"/>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="handleRoleSubmit('roleFormValidate')">提交</Button>
      </div>
    </Modal>

  </Content>
</template>

<script>
  import config from "@/config.js"
  import lib from "@/assets/js/lib/index.js"
  import md5 from 'js-md5'
  import store from '../../../tool/store'

  export default {
    name: 'stores',
    data() {
      return {
        baseUrl: config("baseServerUrl", "."),
        showRoleBox: false,
        userId: 0,
        isAdd: true,
        userInfo: {},
        Search: "",
        deviceSensorAllList: [],
        deviceCameraAllList: [],
        deviceControllerAllList: [],
        deviceAllList: [],
        checkAllGroup: [],
        RoleData: [],
        formValidate: {},
        ruleValidate: {
          UserName: [{
            required: true,
            message: '用户名不能为空',
            trigger: 'blur'
          }],
          Mobile: [{
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          }],
          Roles: [{
            required: true,
            type: 'array',
            message: '请选择角色',
            trigger: 'blur'
          }],
          Password: [
            {required: true, message: '新密码不能为空', trigger: 'blur'},
            {validator: this.passwordCheckValidate, trigger: 'blur'}
          ],
          RPassword: [
            {required: true, message: '确认新密码不能为空', trigger: 'blur'},
            {validator: this.passwordCheckValidate, trigger: 'blur'}
          ],
        },
        roleFormValidate: {
          Level: 1,
          Name: '',
          IsValid: '1',
          Remark: ''
        },
        roleList: [{
          value: 1,
          label: '企业管理员'
        },{
          value: 2,
          label: '普通用户'
        }],
        roleRuleValidate: {
          Name: [{
            required: true,
            message: '请输入角色名称',
            trigger: 'blur'
          }]
        }
      }
    },
    created() {
      var Id = lib.isset(this.$route.query.Id) ? this.$route.query.Id : 0
      this.userId = Id
      if (Id) {
        this.isAdd = false
        let url = this.baseUrl + 'api/userInfo?userid=' + Id
        this.$http.get(url, {}).then(res => {
          this.userInfo = lib.isset(res.data.Data) ? res.data.Data : []
          let roleIds = []
          this.userInfo.Roles.map(function (item) {
            roleIds.push(item.Id)
          })
          this.formValidate = this.userInfo
          this.formValidate.Roles = roleIds
          this.getAllDevice()
        }).catch(error => {
          this.$Message.error('获取用户信息失败' + error.message)
        })
      }else{
        this.isAdd = true
        this.getAllDevice()
      }

      this.getRoleList()
    },
    methods: {
      console() {
      },
      // 检测两次密码是否一致
      passwordCheckValidate(rule, value, callback) {
        if (this.formValidate.Password !== undefined && this.formValidate.RPassword !== undefined) {
          if (this.formValidate.Password !== this.formValidate.RPassword) {
            return callback(new Error('你输入的两次密码不一致'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      },
      getRoleList() {
        let url = this.baseUrl + 'api/auth/roleinfo/getlist'
        this.loading = true
        this.$http.post(url, {
          "PageIndex": 1,
          "PageSize": 9999,
          "SortString": '',
          "SearchString": ''
        }).then(res => {
          this.RoleData = res.data.Data.DataList || []
          this.RoleData.map(function (item) {
            item.LevelFormat = item.Level == 0 ? '超级管理员' : item.Level == 1 ? '企业管理员' : '普通用户'
          })
        }).catch(error => {
          this.loading = false
          this.$Message.error('查询失败，' + error.message)
        })
      },
      addRole() {
        this.showRoleBox = true
      },
      initRoleFormValidate() {
        this.roleFormValidate = {
          Level: 1,
          Name: '',
          IsValid: '1',
          Remark: ''
        }
      },
      handleRoleSubmit(roleFormValidate) {
        this.$refs[roleFormValidate].validate((valid) => {
          if (valid) {
            let data = {
              Id: this.roleFormValidate.Id,
              Level: this.roleFormValidate.Level,
              Name: this.roleFormValidate.Name,
              IsValid: this.roleFormValidate.IsValid,
              Remark: this.roleFormValidate.Remark,
              CompanyId: store.state.usercompanyid
            }

            let url = this.baseUrl + 'api/roleInfo/add'
            this.$http.post(url, data).then(res => {
              if (res.data.StatusCode == 200) {
                this.$Message.success('添加成功!')
                this.showRoleBox = false
                this.initRoleFormValidate()
                this.getRoleList()
              } else {
                this.$Message.error('遇到未知错误，操作失败!');
              }
            }).catch(error => {
              console.error(error)
              this.$Message.error('获取信息失败!' + error.message);
            })
          } else {
            this.$Message.error('请填写相关信息!');
          }
        })
      },

      handleCheckAll(GroupName, type) {
        console.log('触发方法')
        console.log(GroupName)
        console.log(type)

        var data = this.deviceAllList

        if (type == 1) {
          var sensorIsChecked
          for (var i = 0; i < data.length; i++) {
            if (data[i].GroupName == GroupName) {
              sensorIsChecked = !data[i].sensorIsChecked
              data[i].sensorIsChecked = sensorIsChecked
              data[i].sensorIndeterminate = false
              for (var j = 0; j < data[i].Sensors.length; j++) {
                data[i].Sensors[j].isChecked = sensorIsChecked
              }
            }
          }
        } else if (type == 2) {
          var controllerIsChecked
          for (var i = 0; i < data.length; i++) {
            if (data[i].GroupName == GroupName) {
              controllerIsChecked = !data[i].controllerIsChecked
              data[i].controllerIsChecked = controllerIsChecked
              data[i].controllerIndeterminate = false
              for (var j = 0; j < data[i].Controllers.length; j++) {
                data[i].Controllers[j].isChecked = controllerIsChecked
              }
            }
          }
        } else if (type == 3) {
          var cameraIsChecked
          for (var i = 0; i < data.length; i++) {
            if (data[i].GroupName == GroupName) {
              cameraIsChecked = !data[i].cameraIsChecked
              data[i].cameraIsChecked = cameraIsChecked
              data[i].cameraIndeterminate = false
              for (var j = 0; j < data[i].Cameras.length; j++) {
                data[i].Cameras[j].isChecked = cameraIsChecked
              }
            }
          }
        } else if (type == 4) {//irrigation
          var irrigationIsChecked
          for (var i = 0; i < data.length; i++) {
            if (data[i].GroupName == GroupName) {
              irrigationIsChecked = !data[i].irrigationIsChecked
              data[i].irrigationIsChecked = irrigationIsChecked
              data[i].irrigationIndeterminate = false
              for (var j = 0; j < data[i].Irrigations.length; j++) {
                data[i].Irrigations[j].isChecked = irrigationIsChecked
              }
            }
          }
        }

        this.deviceAllList = []
        this.deviceAllList = data
      },
      checkAllGroupChange() {
        console.log('触发单个！')
        var data = this.deviceAllList
        for (var i = 0; i < data.length; i++) {
          var sensorIsCheckedNum = 0
          var sensorNotCheckedNum = 0
          var controllerIsCheckedNum = 0
          var controllerNotCheckedNum = 0
          var cameraIsCheckedNum = 0
          var cameraNotCheckedNum = 0
          var irrigationIsCheckedNum = 0
          var irrigationNotCheckedNum = 0

          //sensor
          for (var j = 0; j < data[i].Sensors.length; j++) {
            if (data[i].Sensors[j].isChecked) {
              sensorIsCheckedNum++
            } else {
              sensorNotCheckedNum++
            }
          }
          if (sensorIsCheckedNum == 0) {
            data[i].sensorIsChecked = false
            data[i].sensorIndeterminate = false
          } else if (sensorNotCheckedNum == 0) {
            data[i].sensorIsChecked = true
            data[i].sensorIndeterminate = false
          } else {
            data[i].sensorIsChecked = false
            data[i].sensorIndeterminate = true
          }

          //controller
          for (var j = 0; j < data[i].Controllers.length; j++) {
            if (data[i].Controllers[j].isChecked) {
              controllerIsCheckedNum++
            } else {
              controllerNotCheckedNum++
            }
          }
          if (controllerIsCheckedNum == 0) {
            data[i].controllerIsChecked = false
            data[i].controllerIndeterminate = false
          } else if (controllerNotCheckedNum == 0) {
            data[i].controllerIsChecked = true
            data[i].controllerIndeterminate = false
          } else {
            data[i].controllerIsChecked = false
            data[i].controllerIndeterminate = true
          }

          //camera
          for (var j = 0; j < data[i].Cameras.length; j++) {
            if (data[i].Cameras[j].isChecked) {
              cameraIsCheckedNum++
            } else {
              cameraNotCheckedNum++
            }
          }
          if (cameraIsCheckedNum == 0) {
            data[i].cameraIsChecked = false
            data[i].cameraIndeterminate = false
          } else if (cameraNotCheckedNum == 0) {
            data[i].cameraIsChecked = true
            data[i].cameraIndeterminate = false
          } else {
            data[i].cameraIsChecked = false
            data[i].cameraIndeterminate = true
          }

          //irrigation
          for (var j = 0; j < data[i].Irrigations.length; j++) {
            if (data[i].Irrigations[j].isChecked) {
              irrigationIsCheckedNum++
            } else {
              irrigationNotCheckedNum++
            }
          }
          if (irrigationIsCheckedNum == 0) {
            data[i].irrigationIsChecked = false
            data[i].irrigationIndeterminate = false
          } else if (irrigationNotCheckedNum == 0) {
            data[i].irrigationIsChecked = true
            data[i].irrigationIndeterminate = false
          } else {
            data[i].irrigationIsChecked = false
            data[i].irrigationIndeterminate = true
          }
        }

        this.deviceAllList = []
        this.deviceAllList = data
      },
      getAllDevice() {
        let url = this.baseUrl + 'api/auth/authaction/getalldevices'
        this.$http.get(url, {}).then(res => {
          var data = res.data.Data || []
          //初始化水肥机数据,保持数据结构一致
          data.map(function (item) {
            if (item.IsForIrrigation) {
              if (item.Irrigation && lib.isArray(item.Irrigation)) {//数组
                item.Irrigations = item.Irrigation
              } else if (item.Irrigation && !lib.isArray(item.Irrigation)) {//对象
                item.Irrigations = [item.Irrigation]
              } else {//空
                item.Irrigations = []
              }
            }else{
              item.Irrigations = []
            }
            return item
          })
          this.deviceAllList = data
          this.combineDeviceData(data)
        }).catch(error => {
          this.$Message.error('查询失败' + error.message)
        })
      },

      combineDeviceData(data) {
        let DeviceSensorIds = this.userInfo.DeviceSensorIds || []
        //初始化数据
        for (var i = 0; i < data.length; i++) {
          for (var j = 0; j < data[i].Sensors.length; j++) {
            if (DeviceSensorIds.indexOf(data[i].Sensors[j].Id) > -1) {
              data[i].Sensors[j].isChecked = true
            } else {
              data[i].Sensors[j].isChecked = false
            }
          }
        }
        let DeviceControllerIds = this.userInfo.DeviceControllerIds || []
        //初始化数据
        for (var i = 0; i < data.length; i++) {
          for (var j = 0; j < data[i].Controllers.length; j++) {
            if (DeviceControllerIds.indexOf(data[i].Controllers[j].Id) > -1) {
              data[i].Controllers[j].isChecked = true
            } else {
              data[i].Controllers[j].isChecked = false
            }
          }
        }
        let CamerasIds = this.userInfo.CamerasIds || []
        //初始化数据
        for (var i = 0; i < data.length; i++) {
          for (var j = 0; j < data[i].Cameras.length; j++) {
            if (CamerasIds.indexOf(data[i].Cameras[j].Id) > -1) {
              data[i].Cameras[j].isChecked = true
            } else {
              data[i].Cameras[j].isChecked = false
            }
          }
        }

        let IrrigationIds = this.userInfo.IrrigationIds || []
        //初始化数据
        for (var i = 0; i < data.length; i++) {
          if(data[i].IsForIrrigation) {
            for (var j = 0; j < data[i].Irrigations.length; j++) {
              if (IrrigationIds.indexOf(data[i].Irrigations[j].Id) > -1) {
                data[i].Irrigations[j].isChecked = true
              } else {
                data[i].Irrigations[j].isChecked = false
              }
            }
          }
        }

        this.deviceAllList = data
        //初始化分组是否选中
        this.checkAllGroupChange()
      },
      // 提交
      handleSubmit(name) {
        console.log('this.formValidate',this.formValidate)

        let DeviceSensorIds = []
        let DeviceControllerIds = []
        let CamerasIds = []
        let IrrigationIds = []
        let Roles = []
        let createOrUpdateUrl = this.baseUrl
        let baseSend = undefined
        let _this = this

        //角色信息
        this.RoleData.map(function (item) {
          if(lib.in_array(item.Id, _this.formValidate.Roles)) {
            Roles.push(item)
          }
        })

        //获取DeviceSensorIds
        var sensor = []
        var camera = []
        var controller = []
        var irrigation = []
        for (var i = 0; i < this.deviceAllList.length; i++) {
          sensor = this.deviceAllList[i].Sensors
          for (var j = 0; j < sensor.length; j++) {
            if (sensor[j].isChecked) {
              DeviceSensorIds.push(sensor[j].Id)
            }
          }

          camera = this.deviceAllList[i].Cameras
          for (var j = 0; j < camera.length; j++) {
            if (camera[j].isChecked) {
              CamerasIds.push(camera[j].Id)
            }
          }

          controller = this.deviceAllList[i].Controllers
          for (var j = 0; j < controller.length; j++) {
            if (controller[j].isChecked) {
              DeviceControllerIds.push(controller[j].Id)
            }
          }

          irrigation = this.deviceAllList[i].Irrigations
          for (var j = 0; j < irrigation.length; j++) {
            if (irrigation[j].isChecked) {
              IrrigationIds.push(irrigation[j].Id)
            }
          }
        }

        if (this.userId) {
          createOrUpdateUrl += 'api/userInfo/update'
          baseSend = 'post'
        } else {
          createOrUpdateUrl += 'api/userinfo/add'
          baseSend = 'post'
          this.formValidate.Password = md5(this.formValidate.Password)
          this.formValidate.RPassword = md5(this.formValidate.RPassword)
        }
        let operation = this.userId ? '编辑' : '新建'
        let data = {
          Id: this.userId,
          UserName: this.formValidate.UserName,
          Password: this.formValidate.Password,
          Email: this.formValidate.Email,
          Remark: this.formValidate.Remark,
          Mobile: this.formValidate.Mobile,
          RealName: this.formValidate.RealName,
          // CreateTime: "2018-07-03T08:39:27.325Z",
          // UpdateTime: "2018-07-03T08:39:27.325Z",
          // ExpireTime: "2018-07-03T08:39:27.325Z",
          Token: "",
          AppKey: "",
          AppSecret: "",
          CompanyName: "",
          CompanyId: 0,
          DeviceSensorIds: DeviceSensorIds,
          DeviceControllerIds: DeviceControllerIds,
          CamerasIds: CamerasIds,
          IrrigationIds: IrrigationIds,
          Roles: Roles
        }

        console.log('tiJiao123',JSON.stringify(data))
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.$http({
              method: baseSend,
              url: createOrUpdateUrl,
              data: data
            }).then(response => {
              if (response.data.Error) {
                this.$Modal.error({
                  title: '操作失败！',
                  content: response.data.Error
                });
              } else {
                this.$Message.success(operation + '用户成功')
                this.$router.push({
                  name: 'userManagement'
                })
              }
              // if (response.data.StatusCode == 401) {
              //   this.$Message.warning(response.data.Error)
              // } else if (response.data.StatusCode == 500) {
              //   this.$Message.warning(response.data.Error)
              // } else {
              //   this.$Message.success(operation + '用户成功')
              //   this.$router.push({
              //     name: 'userManagement'
              //   })
              // }
            }).catch(response => {
              this.$Message.error(operation + '用户失败!' + response.message)
            })
          } else {
            this.$Message.error('请填写必填项')
          }
        })
      },
      // 取消
      handleReset(name) {
        this.$router.push({
          name: 'userManagement'
        })
      }
    },
  }
</script>
<style lang="less">
  .lable-title {
    font-weight: 650;
    font-style: normal;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.847);
    line-height: 24px;
  }

  div.stores_container {
    div.userInfo {
      /*height: 259px;*/
      background: rgba(247, 247, 247, 1);
      padding-top: 20px;
      .form {
        margin-top: 20px;
        /*width: 60%;*/

        /*float: left;*/
        /*.item {*/
          /*float: left;*/
          /*&.margin_small {*/
            /*margin-left: 20px;*/
          /*}*/
          /*&.margin_large {*/
            /*margin-left: 40px;*/
          /*}*/
        /*}*/
      }
      .upload {
        width: 40%;
        float: left;
      }
    }
    div.deviceManage {
      .tabs {
        .search {
          width: 200px;
          height: 32px;
        }
        .searchPic {
          position: relative;
          top: 8px;
          right: 29px;
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
        .date {

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/user/userDetail.vue